























































































import {
  Vue,
  Component,
  Prop,
} from "@/shared/vuepack";
import { Location } from "vue-router";
import { useCustodianSettingsStore } from "@/shared/store/custodianSettings";

@Component({})
export default class ClaimAccountComplete extends Vue {
  @Prop() routeToFinish: Location;

  custodianSettingsStore = useCustodianSettingsStore();

  mounted () {
    this.custodianSettingsStore.getCustodianSettings();
    this.$emit("complete");
  }

  submitOnboardingComplete (): void {
    this.$router.push(this.routeToFinish);
  }
}
